import {createSlice, PayloadAction} from '@reduxjs/toolkit';

interface ISaleAgents {
  phone_number?: string;
  store_name?: string;
  address?: string;
  cardGuid?: string;
}

const initialState: ISaleAgents = {
  phone_number: '',
  store_name: '',
  address: '',
};

export const saleAgentsSlice = createSlice({
  name: 'saleAgent',
  initialState,
  reducers: {
    addSaleAgentForm: (state, action: PayloadAction<ISaleAgents>) => {
      state.phone_number = action.payload.phone_number;
      state.store_name = action.payload.store_name;
      state.address = action.payload.address;
      state.cardGuid = action.payload.cardGuid;
    },

    clearSaleAgentForm: state => {
      state.phone_number = '';
      state.store_name = '';
      state.address = '';
      state.cardGuid = '';
    },
  },
});

export const {addSaleAgentForm, clearSaleAgentForm} = saleAgentsSlice.actions;

export default saleAgentsSlice.reducer;
